module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/c83c5b739c000eb8e99ff589510d5642.png";